import type { InventoryScreenRow } from './inventoryView';
import { normalizeLocationCode, searchedCode } from './inventoryView';

export interface LocationStock {
  locationCode: string;
  rows: InventoryScreenRow[];
  onHand: number;
  reserved: number;
  available: number;
}

/** Only a whole known location selects a card; SKU/name searches keep their existing behavior. */
export const exactStockLocation = (rows: InventoryScreenRow[], query: string): string | null => {
  const code = searchedCode(query);
  if (!code) {
    return null;
  }
  return rows.find((row) => normalizeLocationCode(row.locationCode) === code)?.locationCode ?? null;
};

/** Physical availability splits On Hand once; server pickability is a separate dispatch restriction. */
export const locationStock = (rows: InventoryScreenRow[], locationCode: string): LocationStock => {
  const here = rows.filter((row) => row.locationCode === locationCode);
  const onHand = here.reduce((total, row) => total + row.onHand, 0);
  const reserved = here.reduce((total, row) => total + row.reserved, 0);
  return { locationCode, rows: here, onHand, reserved, available: onHand - reserved };
};
